module.exports = __webpack_public_path__ + "img/Icon_Historial_de_Citas.3fb554d4.svg";